import { connect } from 'react-redux'

import GestionDrivers from '../../../pages/settings/Drivers'

import { getErrorMessageConfig } from '../../../redux/configuration/selectors'
import { removeErrorConfig } from '../../../redux/configuration/actions'
import {
  getDriversSettings,
  getDriversSettingsCount,
  getDriversSettingsListIsLoading,
  getErrorMessageDriversSettings,
  getIsErrorFetchDriversSettings,
  getIsSuccessRefreshDriversSettings,
  getSuccessDriversSettings,
} from '../../../redux/driver/selectors'
import {
  fetchDrivers,
  onAjoutSearchDriver,
  pageChangedDrivers,
  pageLimitChangedDrivers,
  removeErrorDriver,
  resetDriversConfig,
  resetSuccessActionDrivers,
} from '../../../redux/driver/actions'

const mapStateToProps = (state) => ({
  isLoadingDriverList: getDriversSettingsListIsLoading(state),
  drivers: getDriversSettings(state),
  driverCount: getDriversSettingsCount(state),
  errorMessage: getErrorMessageDriversSettings(state),
  isErrorFetch: getIsErrorFetchDriversSettings(state),
  isSuccessRefresh: getIsSuccessRefreshDriversSettings(state),
  success: getSuccessDriversSettings(state),
  errorMessageConfig: getErrorMessageConfig(state),
})

const mapDisptachToProps = (dispatch) => ({
  fetchData: () => {
    dispatch(fetchDrivers())
  },
  pageLimitChanged: (limit) => {
    dispatch(pageLimitChangedDrivers(limit))
    dispatch(fetchDrivers())
  },
  pageChanged: (offset) => {
    dispatch(pageChangedDrivers(offset))
    dispatch(fetchDrivers())
  },
  removeError: () => dispatch(removeErrorDriver()),
  removeErrorConfig: () => dispatch(removeErrorConfig()),
  resetSuccessAction: () => dispatch(resetSuccessActionDrivers()),
  onCloseReset: () => dispatch(resetDriversConfig()),

  searchData: (search) => {
    dispatch(onAjoutSearchDriver(search))
    dispatch(fetchDrivers())
  },
})

export default connect(mapStateToProps, mapDisptachToProps)(GestionDrivers)
